export const dbmScrollToEnd = ['$document','$timeout',($document,$timeout) => {
    return {
        restrict: 'A',
        link: (scope, $element, attrs) => {
            $element.on('click', event => {
                if ($document && $document.length > 0)
                $timeout(() => {
                    let source = null;
                    if (attrs.scrollSource) {
                        source = $document[0].querySelector(attrs.scrollSource);
                    } else {
                        source = event.currentTarget.nextElementSibling;
                    }
                    const container = $document[0].querySelector(attrs.scrollContainer);
                    const lackingScrollHeight = source.getBoundingClientRect().bottom - container.getBoundingClientRect().bottom;
                    if(lackingScrollHeight>0)
                    container.scrollTop += lackingScrollHeight;
                }, 50, true);
            });
            scope.$on('$destroy', () => {
                $element.unbind('click');
            });
        }
    };
}];



// WEBPACK FOOTER //
// ./src/app/common/directives/dbmScrollToEnd.js